import { connect } from 'react-redux';
import LicenceManagement from '../components';
import ILicenceManagementProps from '../entities/ILicenceManagementProps';
import { closeFlexPanelByIdTransactionAction } from '../../../app-main/actions';
import { WebInterfaceBaseState } from '../../../common/base/state';

const mapStateToProps = function (
	state: WebInterfaceBaseState,
	props: ILicenceManagementProps
): ILicenceManagementProps {
	return;
};

const mapDispatchToProps = function (dispatch: Function): ILicenceManagementProps {
	return {
		closeFlexPanel: function (panelId: string) {
			dispatch(closeFlexPanelByIdTransactionAction(panelId));
		}
	};
};

const LicenceManagementContainer = connect(mapStateToProps, mapDispatchToProps)(LicenceManagement);
export default LicenceManagementContainer;
